<div class="no-license">
  <div>{{"LicenseMissing" | cpLabelTranslate | async}}</div>
</div>
